import chroma from "chroma-js";
const mixColor = (originalColor, adjustColor, ratio = 0.15) => chroma.mix(originalColor, adjustColor, ratio).hex();
export default mixColor;
